import {CaretUpFilled} from '@ant-design/icons';
import {Col, Collapse, Row} from 'antd';
import {Pagination, Checkbox, Tooltip} from 'antd';
import classNames from 'classnames';
import {ReactNode, useEffect, useState} from 'react';
import {getLocalesByKey as t} from '@/utils/translation';
import styles from './style.module.scss';
import {ChevronDown, ChevronUp} from 'react-feather';
import classnames from 'classnames';
import {faFilter, faCaretDown, faCaretUp} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
// import {NextImg} from '@/utils/nextImg';

import {toJS} from 'mobx';
interface filters {
  label: string;
  checked: boolean;
  disabled?: boolean;
  disabledTooltip?: string;
  onChange: () => void;
}

interface columnTitle {
  title?: string;
  sorter?: boolean;
  sortKey?: string | number;
}

interface Props {
  className?: string;
  icon?: ReactNode;
  title?: string;
  description?: string | ReactNode;
  descriptionColor?: string;
  colTitle1?: string;
  colTitle2?: columnTitle;
  colTitle3?: string;
  colTitle4?: string;
  data?: any;
  dataRenderer?: any;
  pageSize?: any;
  footer?: ReactNode;
  isCollapse?: boolean;
  defaultActive?: boolean;
  filters?: filters[];
  plan?: any;
  warningBar?: ReactNode;
}

export const AnalyticsCollapseCard = ({
  className,
  icon,
  title,
  description,
  descriptionColor,
  colTitle1,
  colTitle2 = {
    title: null,
    sorter: false,
    sortKey: null,
  },
  colTitle3,
  colTitle4,
  data,
  dataRenderer,
  pageSize,
  footer,
  isCollapse = true,
  defaultActive = false,
  filters,
  plan = true,
  warningBar,
}: Props) => {
  const [pageNumber, setPageNumber] = useState(1);
  const [checkData, setCheckData] = useState(false);
  const [isFilterOpened, setIsFilterOpened] = useState(false);
  const [sortOrder, setSortOrder] = useState('');
  const [formatData, setFormatData] = useState(null);
  const [activeKey, setActiveKey] = useState(['']);


  const getData = () => {
    if (pageSize) {
      return formatData?.slice((pageNumber - 1) * pageSize, pageNumber * pageSize);
    }
    return formatData;
  };
  useEffect(() => {
    if (getData()?.length > 0 || formatData === undefined || footer) {
      setCheckData(isCollapse);
    }
  }, [getData]);

  useEffect(() => {
    let newData = [];
    if (data) {
      newData = data.map(item => {
        return toJS(item);
      });
    }
    setFormatData(newData);
  }, [JSON.stringify(data)]);

  useEffect(() => {
    if (defaultActive) {
      setActiveKey([title]);
    }
  }, [defaultActive]);

  const sortData = (sortBy: string | number) => {
    const formatArray = [...data];
    if (sortOrder === '') {
      setSortOrder('desc');
      setFormatData(formatArray.sort((a, b) => {
        if (b[sortBy] < a[sortBy]) return -1;
      }));
    } else if (sortOrder === 'desc') {
      setSortOrder('asc');
      setFormatData(formatArray.sort((a, b) => {
        if (a[sortBy] < b[sortBy]) return -1;
      }));
    } else if (sortOrder === 'asc') {
      setSortOrder('');
      setFormatData(data);
    }
  };

  const changeActiveKey = key => {
    setActiveKey(key);
  };


  return (
    <Collapse
      className={classNames(styles.analyticsCollapseCard, className, !isCollapse ? styles.analyticsHideArrow : '', checkData ? '' : styles.analyticsHideArrow )}
      expandIconPosition='right'
      bordered={false}
      /*
      * active key was added to expand the default panel (set from parent) after the data comes
      * this logic disables automatically opening and closing other panels
      * therefore we use onchange, to change the key of active panel programmatically
      * we also check if we have data or footer cuz that is the only incoming data
      * if the Panel doesn't have data and footer it wont be expandable
      */
      activeKey={activeKey && (formatData?.length || footer) ? activeKey : []}
      onChange={changeActiveKey}
      expandIcon={({isActive}) => isCollapse ? (
        <CaretUpFilled className={styles.expandIcon} rotate={isActive ? 0 : 180} />
      ) : null}
    >
      <Collapse.Panel
        key={title}
        header={
          <div className={styles.header}>
            <div className={styles.headerRight}>
              {icon}
              <div className={styles.title}>{title}</div>
            </div>
            <div style={{color: `${descriptionColor ? descriptionColor : '#fff'}`, textAlign: 'right', maxWidth: '50%'}}>
              {description}
            </div>
          </div>
        }
      >
        <div className={styles.divider}></div>
        {warningBar && warningBar}
        {/* if we have 4 columns */}
        {colTitle3 && colTitle4 ?
          <Row justify='space-between' gutter={24} style={{marginBottom: '10px', marginRight: '10px'}}>
            <Col span={15} style={{fontSize: 10}}>
              <div className={styles.colTitle} style={{fontSize: 10}}>
                {colTitle1}
              </div>
            </Col>
            <Col span={4} style={{padding: 0}}>
              <div className={styles.colTitle} style={{fontSize: 10}}>
                {colTitle2.title}
              </div>
            </Col>
            {colTitle3 ?
              <Col span={2} style={{padding: 0}}>
                <div className={styles.colTitle} style={{fontSize: 10}}>
                  {colTitle3}
                </div>
              </Col> : null}
            {colTitle4 ?
              <Col span={2} style={{padding: 0}}>
                <div className={styles.colTitle} style={{fontSize: 10}}>
                  {colTitle4}
                </div>
              </Col> : null}
          </Row> :
          <Row justify='space-between'>
            <Col>
              <div className={styles.colTitle}>
                {colTitle1}
              </div>
            </Col>
            <Col>
              <div className={styles.colTitle} onClick={() => {
                if (colTitle2.sorter && colTitle2.sortKey && data && data.length) {
                  sortData(colTitle2.sortKey);
                }
              }}>
                {colTitle2.title}
                {colTitle2.sorter && colTitle2.sortKey && data && data.length ?
                  <div style={{display: 'flex', flexDirection: 'column', marginLeft: '5px'}}>
                    <FontAwesomeIcon icon={faCaretUp} style={{marginTop: '-2px'}}color={sortOrder === 'asc' ? 'white' : 'gray'}/>
                    <FontAwesomeIcon icon={faCaretDown} style={{marginTop: '-4px'}} color={sortOrder === 'desc' ? 'white' : 'gray'}/>
                  </div> :
                  null}

              </div>
            </Col>
          </Row>
        }

        {getData()?.map((x, i) => dataRenderer(x, i))}
        <div style={{display: 'flex', justifyContent: 'space-between'}}>
          {pageSize && (pageSize < data?.length) && (
            <>

              <Pagination
                className={classnames(styles.paginationStyle, !plan && styles.singlePageBlur)}
                defaultCurrent={1}
                pageSize={pageSize}
                total={data?.length}
                size='small'
                showSizeChanger={false}
                showQuickJumper={false}
                onChange={pageNumber => setPageNumber(pageNumber)}
                disabled={!plan}
              />
            </>
          )}
          {filters && filters.length >= 1 ?
            (<div
              onClick={()=> setIsFilterOpened(!isFilterOpened)}
              className={styles.filters}>
              {/* <NextImg src='img/icon/filters-icon.svg'/> */}
              <FontAwesomeIcon icon={faFilter} />
              <div style={{display: 'flex', marginTop: '3px'}}>
                <span className={styles.filtersText}> {`${t('filters')}: ${filters.filter(filter => filter.checked).length}`}</span>
                <span className={styles.chevron}>
                  {isFilterOpened ? <ChevronUp size={16} /> : <ChevronDown size={16}/>}
                </span>
              </div>
              {
                isFilterOpened && (
                  <div
                    className={styles.filtersItems}
                    onClick={e => e.stopPropagation()}>
                    <div className={styles.OptionContainer}>
                      {filters.map((filter, idx) => (
                        filter.disabled ?
                          <Tooltip key={idx} title={filter.disabledTooltip}>
                            <Checkbox
                              disabled={filter.disabled}
                              key={idx}
                              autoFocus={true}
                              defaultChecked={false}
                              checked={filter.checked}
                              onChange={() => {
                                filter.onChange();
                                setIsFilterOpened(!isFilterOpened);
                              }}>
                              <span className={styles.checkboxLabel}>{filter.label}</span>
                            </Checkbox>
                          </Tooltip>:
                          <Checkbox
                            disabled={filter.disabled}
                            key={idx}
                            autoFocus={true}
                            defaultChecked={false}
                            checked={filter.checked}
                            onChange={() => {
                              filter.onChange();
                              setIsFilterOpened(!isFilterOpened);
                            }}>
                            <span className={styles.checkboxLabel}>{filter.label}</span>
                          </Checkbox>
                      ))
                      }
                    </div>
                  </div>
                )
              }
            </div>) : null }
        </div>
        {footer}
      </Collapse.Panel>
    </Collapse>
  );
};
